import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Quiero que interpretes una **Tirada de Temporada Actual del Alma** con 10 cartas, ayudando al consultante ${
        data.consultante
    } a comprender qué estación o ciclo del alma está transitando en este momento de su vida, ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta que realiza el consultante: ' +
              data.consulta +
              ','
            : ''
    } según estas cartas: **Energía de la temporada actual (¿qué estación o energía del alma está transitando ahora?):** ${cardLabel(
        cards[0]
    )}, **Intensidad o duración aproximada (¿qué tan fuerte o cuánto tiempo puede durar esta temporada?):** ${cardLabel(
        cards[1]
    )}, **Propósito principal (¿para qué está esta temporada? ¿Qué quiere trabajar mi alma?):** ${cardLabel(
        cards[2]
    )}, **Lección secundaria / sombra (¿qué otra lección o aspecto sombra está presente?):** ${cardLabel(
        cards[3]
    )}, **Qué necesita ser soltado (¿qué está invitado/a a soltar en este ciclo?):** ${cardLabel(
        cards[4]
    )}, **Qué necesita ser cultivado (¿qué está invitado/a a nutrir o abrirse a recibir?):** ${cardLabel(
        cards[5]
    )}, **Influencias externas (¿qué factores externos están afectando esta temporada?):** ${cardLabel(
        cards[6]
    )}, **Resistencia o miedo (¿qué parte del consultante se está resistiendo o teniendo miedo?):** ${cardLabel(
        cards[7]
    )}, **El regalo/bendición que trae (¿cuál es el regalo oculto o la bendición de esta temporada?):** ${cardLabel(
        cards[8]
    )} y **Consejo del alma + transición (¿cómo transitarla con gracia? ¿qué temporada se asoma después?):** ${cardLabel(
        cards[9]
    )}. Explica detalladamente cada carta y su significado en la posición donde ha salido. Teje una lectura coherente sobre el ciclo actual del alma: conecta la energía de la temporada, su propósito, las lecciones, lo que debe soltarse y cultivarse, y la transición hacia lo que viene. Detecta patrones, resistencias y bendiciones ocultas. Proporciona consejos prácticos y espirituales para transitar esta temporada con conciencia y gracia. Mantén un tono profesional, empático, profundo y comprensible. Dirígete directamente al consultante, no utilices la tercera persona refiriéndote al consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 párrafos después de la lectura, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
